export const selectors = {
  html: {
    // @TODO will need to be revisited once we start using non-MJML documents
    root: 'body > div',
    layout: 'body > div > table',
    field: 'h1, h2, h3, h4, h5, p, li, img',
    richText: '*:has(> :is(h1, h2, h3, h4, h5, p))',
  },
  mjml: {
    root: 'mj-body',
    layout: 'mj-wrapper[is-layout]',
    field: 'mj-text[show-in-editor="true"], mj-button[show-in-editor="true"], mj-image[show-in-editor="true"]',
    richText: 'mj-text[show-in-editor="true"], mj-button[show-in-editor="true"]',
    cta: 'mj-button',
  },
};

export const fontTools = [
  'bold',
  'italic',
  'underline',
  '',
  'textDirection',
  '',
  'superscript',
  'subscript',
  '',
  'orderedList',
  'bulletList',
  'textAlign',
];

export const editableFields = ['mj-text', 'mj-image', 'mj-button'];
